(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define([], factory);
  } else if (typeof exports !== "undefined") {
    factory();
  } else {
    var mod = {
      exports: {}
    };
    factory();
    global.flowtypes = mod.exports;
  }
})(this, function () {
  "use strict";
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/components/FileUploadStatusBox/flowtypes.js
// module id = 364
// module chunks = 1